import { type Router, useRouter } from 'vue-router';
import type { DataTableRowClickEvent } from 'primevue/datatable';

interface RowLinkNavigationOptions<T> {
  rowLink: (data: T) => string | Parameters<Router['resolve']>[0] | null;
  alwaysOpenLinkInNewTab?: boolean;
}

export function useRowLinkNavigation<T>(options: RowLinkNavigationOptions<T>) {
  const router = useRouter();

  const onRowClicked = (e: DataTableRowClickEvent) => {
    if (!options.rowLink || !(e.originalEvent instanceof MouseEvent)) {
      return;
    }

    // Negeer klikken op links binnen een rij.
    if (e.originalEvent.target instanceof HTMLAnchorElement) {
      return;
    }

    const route = options.rowLink(e.data);
    if (!route) {
      return;
    }

    const { alwaysOpenLinkInNewTab } = options;

    if (alwaysOpenLinkInNewTab || e.originalEvent.ctrlKey || e.originalEvent.metaKey) {
      window.open(getRouteUrl(router, route), '_blank');
      return;
    }

    const iFrame = document.getElementById('menu-iframe');
    if (iFrame) {
      (iFrame as HTMLIFrameElement).src = getRouteUrl(router, route);
      return;
    }

    if (typeof route === 'string') {
      window.location.href = route;
    } else {
      router.push(route);
    }
  };

  return { onRowClicked };
}

function getRouteUrl(router: Router, route: string | Parameters<Router['resolve']>[0]) {
  return typeof route === 'string' ? route : router.resolve(route).href;
}
